
import React from 'react'
import style from 'styled-components'
import BorderImage from '../../../../assets/img/border-line.png'

function Kitchen() {
  return (
    <KitchenContainer>
        <Kitchens>
            <Title>
                <h1>
                KITCHEN AND BATHROOM PRODUCTS
                </h1>
                <p>Wide selection of kitchen and bathroom products complemented by a variety of finishing accessories.
                </p>
                <BorderImg BorderImage={BorderImage}>
                </BorderImg>
            </Title>
            <TypeContainer>
                <Type>
                    <h4>KITCHEN CABINETS</h4>
                    <p>
                    We offer a great choice of traditional and innovative cabinet designs at affordable prices. With an incredible 3-day ready time.
                    </p>
                </Type>
                <Type>
                    <h4>BATHROOM VANITIES</h4>
                    <p>
                    A vanity is an essential part of any bathroom. Save time and money with exquisite bathroom vanity styles.
                    </p>
                </Type>
                <Type>
                    <h4>COUNTERTOPS</h4>
                    <p>
                    Granite, quarts, marble countertops will make your kitchen shine. The stone is cut and delivered in 3 business days.
                    </p>
                </Type>
                <Type>
                    <h4>GLASS SHOWER SYSTEMS</h4>
                    <p>
                    Custom glass shower doors and enclosures of stunning quality at manufacturer-direct prices. A wide selection in stock every day.
                    </p>
                </Type>
            </TypeContainer>
        </Kitchens>
    </KitchenContainer>
  )
}

const KitchenContainer = style.div`
    background:gary;
    padding:110px 0 80px;
`
const Kitchens = style.div`
    max-width:1150px;
    margin:0 auto;
    text-align:center;
`
const Title = style.div`
    margin-bottom:70px;
    h1{
        margin-bottom:10px;
        font-size:35px;
        letter-spacing:3px;
        font-weight:bold;
    }
    p{
        margin-bottom:24px;
    }
`
const BorderImg = style.div`
    
 &:after{
    content: '';
    display: block;
    background: url(${props=>props.BorderImage}) no-repeat center center;
    height: 27px;
    width: 100px;
    display: block;
    margin: 0 auto;
    margin-bottom: 70px;
 }
`
const TypeContainer = style.div`
   max-width:1170px;
   display:flex;
   justify-content:center;
   @media (max-width:765px){
    flex-direction:column;
  }
`

const Type = style.div`
    padding-right:10px;
    padding-left:35px;
    width:25%;
    @media (max-width:765px){
       width:100%;
       height:130px;
      }
    h4{
        color: #1b1313;
        font-family: 'Roboto', sans-serif;
        font-size: 20px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 8px;
        text-align:left;
    }
    p{
        font-size: 16px;
        color: #676767;
        line-height: 26px;
        font-weight: 400;
        text-align:left;
    }
`



export default Kitchen